import classNames from "classnames";
import Tag from "components/Tag/Tag";
import React from "react";
import { formatLongDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";
import { displayUserText } from "./SubscriptionUtils";

interface SubscriptionCardProps {
  start: Date
  type: server.dto.SubscriptionType
  billingCycle: server.dto.BillingCycle
  useColor: boolean
  users: number
  discount?: server.dto.Percentage
  discountReason?: string
  invoice?: server.dto.InvoiceSmall
  onClick?: (item) => void
  subscriptionId?: number
  isNext?: boolean
}

const SubscriptionCard = (props: SubscriptionCardProps) => {
  const { type, billingCycle, start, useColor, users, discount, discountReason, invoice, onClick } = props;

  const displayInvoice = type.value === "paid" || type.value === "readOnly" || (invoice);

  const cssClasses = classNames({
    "white-text": useColor,
    hoverable: (props.onClick != null)
  });

  const userLabel = users === 1 ? "1 user" : `${users} users`;

  const percentage: server.dto.Percentage = (discount) || ({ value: 0, text: "0%" });

  //  const style = useColor ? { backgroundColor: type.hexColor } : {};

  const documentNumberFriendly = (invoice?.documentNumber) ? invoice.documentNumber : RESX.Document.ProForma;

  const invoiceUrl = (invoice) ? <a href={routes.invoice_Detail(invoice.invoiceId).absolute} style={{ textDecoration: "underline" }}>{documentNumberFriendly}</a> : "no invoice";

  const isSettled = (invoice?.totalOutstanding.amount === 0);

  const isOverDue = (invoice?.daysOverDue > 0);

  const settledBgColor = isSettled
    ? "green"
    : isOverDue
      ? "red"
      : "orange";

  const style = useColor
    ? { backgroundColor: type.hexColor }
    : { borderLeft: `solid 10px ${type.hexColor}` };

  const daysOverDue = (isOverDue && !isSettled) && <Tag
    label={`${invoice?.daysOverDue} days over due`}
    color={"green"} />;

  return <div className={cssClasses} style={style} onClick={onClick}>
    <div className="grow1" style={{ flexBasis: 0 }}>
      <div className="margin-bottom-mini">
        <h3>{formatLongDate(start)}</h3>
      </div>

      <div>
        {type.internalText}
      </div>
      {props.subscriptionId && <div className="s1_small">subscription: {props.subscriptionId}</div>}
    </div>
    <div className="grow1" style={{ flexBasis: 0 }}>
      {displayUserText(type.value) && <>{userLabel}</>}
    </div>
    <div className="grow1" style={{ flexBasis: 0 }}>
      {percentage.value > 0 && <>
        <div>{`${percentage.text} discount`}</div>
        <div className="s1_small">{discountReason}</div>
      </>}
    </div>
    {displayInvoice && <>
      <div className="grow1" style={{ flexBasis: 0, textAlign: "right" }}>
        <div className="margin-bottom-small">
          <h3>{billingCycle.text}</h3>
        </div>
        {!props.isNext && <div className="margin-bottom-small">{invoiceUrl}</div>}
        {(invoice) && <Tag
          label={invoice?.total.formatted}
          color={settledBgColor} />}
        {daysOverDue}
      </div>
    </>}
  </div>;
};

export default SubscriptionCard;